type TDataLayerArgs = Record<string, unknown>

type TDataLayer = TDataLayerArgs[]

declare global {
  interface Window {
    dataLayer: { push: (...args: TDataLayer) => void }
  }
}

const platformMapper = (platform: string) => {
  if (platform === 'netshoes') return 'netshoes'

  if (platform === 'magazineluiza') return 'magalu'

  return ''
}

const pushToDataLayer = (args: TDataLayerArgs): void => {
  const event = {
    event: 'clickEvent',
    eventAction: 'click',
    eventNonInteraction: '0',
    hitTimestamp: Date.now().toString(),
    ...args,
    platform: platformMapper(sessionStorage.getItem('channel') || ''),
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(event)
}

export type { TDataLayer, TDataLayerArgs }

export { pushToDataLayer }
